import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5H4V4.5H12V2.5ZM7 5.5H9V7.5H11V9.5H9V13.5H7V9.5H5V7.5H7V5.5ZM5 9.5V11.5H3V9.5H5ZM11 9.5H13V11.5H11V9.5Z\" fill=\"#A6A6A6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol